import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-email-confirm-modal",
  templateUrl: "./app-email-confirm-modal.component.html",
  styleUrls: ["./app-email-confirm-modal.component.scss"],
})
export class EmailConfirmModalComponent implements OnInit {
  @Output()
  onCloseModalTriggered: EventEmitter<any> = new EventEmitter();

  @Output()
  submitTriggered: EventEmitter<any> = new EventEmitter();

  @Input("selectedRole") set selectedRoleValue(val: any) {
    if (val) {
      this.id = val.id;
    }
  }
  @Input()
  title: any;

  @Input()
  message: any;

  @Input()
  buttonName: any;
  id: any;

  constructor() {}

  ngOnInit() {}

  save() {
    this.submitTriggered.next(this.id);
    setTimeout(() => {
      this.onCloseModalTriggered.next(true);
    }, 300);
  }

  closeModal() {
    this.onCloseModalTriggered.next(true);
  }
}
